import { Orientation, type SerializedDockview } from 'dockview';
import type { PanelType, TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

interface DealerWorkflowPanel {
  type: PanelType;
  title: string;
}

function createPanel({ title, type }: DealerWorkflowPanel): TypedGroupviewPanelState {
  return {
    id: type,
    contentComponent: type,
    title,
    params: { type, tabs: undefined },
  } as TypedGroupviewPanelState;
}

export function createDealerWorkflowLayout(workflowPanels: DealerWorkflowPanel[]): SerializedDockview {
  const panels = Object.fromEntries(workflowPanels.map(panel => [panel.type, createPanel(panel)]));

  return {
    grid: {
      root: {
        type: BRANCH,
        data: workflowPanels.map(panel => ({
          type: LEAF,
          visible: true,
          data: {
            views: [panel.type],
            activeView: panel.type,
            id: panel.type,
          },
          size: 450,
        })),
        size: 1600,
      },
      width: 1600,
      height: 900,
      orientation: Orientation.HORIZONTAL,
    },
    panels,
  };
}
